import React from 'react';

export default function PrintButton(props) {
  return (
    <button onClick={window.print} disabled={props.disabled} className="btn btn-success">Печать</button>
  )
}